import { AppDivider, AppButton, AppGroup, AppSegment } from 'client/ui-building-blocks'

const ButtonPreview = () => {
  return (
    <>
      <AppSegment headerProps={{ text: 'Variant', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Success" variant="success" />
          <AppButton text="Info" variant="info" />
          <AppButton text="Warning" variant="warning" />
          <AppButton text="Error" variant="error" />
          <AppButton text="Outlined" variant="outlined" />
          <AppButton text="Blank" variant="blank" />
          <AppButton text="Dark" variant="dark" />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Disabled', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Success" variant="success" disabled />
          <AppButton text="Info" variant="info" disabled />
          <AppButton text="Warning" variant="warning" disabled />
          <AppButton text="Error" variant="error" disabled />
          <AppButton text="Outlined" variant="outlined" disabled />
          <AppButton text="Blank" variant="blank" disabled />
          <AppButton text="Dark" variant="dark" disabled />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Loading', marginBottom: 'small' }}>
        <AppButton text="Fetch" loading />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Size', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Small" size="small" />
          <AppButton text="Medium" size="medium" variant="info" />
          <AppButton text="Large" size="large" variant="error" />
        </AppGroup>
        <AppDivider />
        <AppButton text="Full width" fullWidth variant="warning" />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Icon', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Approved" iconName="CHECK" />
          <AppButton text="Share" iconName="SHARE" variant="info" />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Size + icon', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Small" size="small" iconName="CHECK" />
          <AppButton text="Medium" size="medium" iconName="CHECK" />
          <AppButton text="Large" size="large" iconName="CHECK" />
        </AppGroup>
        <AppDivider />
        <AppGroup>
          <AppButton
            text="Small"
            size="small"
            iconName="CLOSE"
            iconPosition="right"
            variant="dark"
          />
          <AppButton
            variant="dark"
            text="Medium"
            size="medium"
            iconName="CLOSE"
            iconPosition="right"
          />
          <AppButton
            variant="dark"
            text="Large"
            size="large"
            iconName="CLOSE"
            iconPosition="right"
          />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Link', marginBottom: 'small' }}>
        <AppButton
          variant="info"
          text="Google"
          iconName="SEARCH"
          href="https://google.com"
        />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Alignment', marginBottom: 'small' }}>
        <AppButton text="Left aligned" />
        <AppDivider />
        <AppButton text="Centered" position="center" variant="info" />
        <AppDivider />
        <AppButton text="Right aligned" position="right" variant="warning" />
        <AppDivider />
        <AppButton text="Text left aligned" fullWidth textPosition="left" />
        <AppDivider />
        <AppButton
          text="Text right aligned"
          fullWidth
          textPosition="right"
          variant="info"
        />
      </AppSegment>
    </>
  )
}

export default ButtonPreview
